// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.address-block-container {
  display: flex;
  justify-content: space-between;
}

.student-info-container-outside {
  display: flex;
  justify-content: space-between;
}
.student-info-container-outside .student-info-container {
  display: flex;
  flex-direction: column;
  width: 48%;
}
.student-info-container-outside .student-info-container .input-container {
  font-weight: 500;
  font-size: 0.9rem;
  margin: 10px 0;
  display: flex;
  flex-direction: column;
}
.student-info-container-outside .student-info-container .input-container input[type=radio] {
  width: 20px;
  height: 20px;
}
.student-info-container-outside .student-info-container .input-container .radio-values-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 5px;
}
.student-info-container-outside .student-info-container .input-container .radio-label {
  margin-left: 5px;
}
.student-info-container-outside .student-info-container .input-container .dob-container {
  display: flex;
  flex-direction: row;
}
.student-info-container-outside .student-info-container .input-container .dob-container .dob-group {
  display: flex;
  flex-direction: column;
  width: 120px;
  margin: 0 5px;
}
.student-info-container-outside .student-info-container .input-container .yep {
  border-radius: 5px;
  border: none;
  border: 1px solid #808080;
  padding: 5px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
}
.student-info-container-outside .student-info-container .input-container select {
  border-radius: 5px;
  border: none;
  border: 1px solid #808080;
  padding: 5px;
  background: white;
}
.student-info-container-outside .student-info-container .input-container .address-search {
  width: 100%;
}
.student-info-container-outside .student-info-container .input-container .address-search input[type=text] {
  width: 100%;
}
.student-info-container-outside .student-info-container .search-address-container {
  display: flex;
}
.student-info-container-outside .student-info-container .search-address-container #address1 {
  width: 100%;
}
.student-info-container-outside .student-info-container .search-address {
  margin-left: 20px;
}
.student-info-container-outside .student-info-container input {
  border-radius: 5px;
  border: none;
  border: 1px solid #808080;
  padding: 5px;
}
.student-info-container-outside .student-info-container .student-address-text {
  font-size: 0.9rem;
}
.student-info-container-outside .student-info-container .student-legal-address-container {
  border-radius: 5px;
  border: 1px solid;
  padding: 10px;
  margin-bottom: 10px;
}

@media only screen and (max-width: 1080px) {
  .dob-container {
    flex-wrap: wrap;
  }
  .dob-container .dob-group {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Guardian_StudentForm.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;EACA,8BAAA;AAUJ;;AAPA;EACI,aAAA;EACA,8BAAA;AAUJ;AARI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AAUR;AATQ;ECcJ,gBAAA;EACA,iBAAA;EACA,cAAA;EDdQ,aAAA;EACA,sBAAA;AAaZ;AAZY;EACI,WAAA;EACA,YAAA;AAchB;AAZY;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;AAchB;AAXY;EACI,gBAAA;AAahB;AAXY;EACI,aAAA;EACA,mBAAA;AAahB;AAXgB;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAapB;AATY;EC1CR,kBAgCsB;EACtB,YAAA;EACA,yBAAA;EACA,YAAA;EDSY,gBAAA;EACA,aAAA;EACA,8BAAA;AAchB;AAZY;EChDR,kBAgCsB;EACtB,YAAA;EACA,yBAAA;EACA,YAAA;EDeY,iBAAA;AAiBhB;AAdY;EACI,WAAA;AAgBhB;AAfgB;EACI,WAAA;AAiBpB;AAbQ;EACI,aAAA;AAeZ;AAdY;EACI,WAAA;AAgBhB;AAbQ;EACI,iBAAA;AAeZ;AAbQ;ECrEJ,kBAgCsB;EACtB,YAAA;EACA,yBAAA;EACA,YAAA;ADqDJ;AAhBQ;EACI,iBAAA;AAkBZ;AAhBQ;EC3EJ,kBD4E8B;EACtB,iBAAA;EACA,aAAA;EACA,mBAAA;AAkBZ;;AAbA;EACI;IACI,eAAA;EAgBN;EAfM;IACI,WAAA;EAiBV;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.address-block-container {\n    display: flex;\n    justify-content: space-between;\n}\n\n.student-info-container-outside {\n    display: flex;\n    justify-content: space-between;\n\n    .student-info-container {\n        display: flex;\n        flex-direction: column;\n        width: 48%;\n        .input-container {\n            @include standardInputContainer;\n            display: flex;\n            flex-direction: column;\n            input[type=\"radio\"] {\n                width: 20px;\n                height: 20px;\n            }\n            .radio-values-container {\n                display: flex;\n                align-items: flex-start;\n                margin-bottom: 5px;\n            }\n\n            .radio-label {\n                margin-left: 5px;\n            }\n            .dob-container {\n                display: flex;\n                flex-direction: row;\n\n                .dob-group {\n                    display: flex;\n                    flex-direction: column;\n                    width: 120px;\n                    margin: 0 5px;\n                }\n            }\n\n            .yep { // small labels above each input on student info page\n                @include standardInput();\n                font-weight: 600;\n                display: flex;\n                justify-content: space-between\n            }\n            select {\n                @include standardInput();\n                background: white;\n            }\n\n            .address-search {\n                width: 100%;\n                input[type=text] {\n                    width: 100%;\n                }\n            }\n        }\n        .search-address-container {\n            display: flex;\n            #address1 {\n                width: 100%;\n            }\n        }\n        .search-address {\n            margin-left: 20px;\n        }\n        & input {\n            @include standardInput()\n        }\n        .student-address-text {\n            font-size: .9rem;\n        }\n        .student-legal-address-container {\n            @include borderRadius(5px);\n            border: 1px solid;\n            padding: 10px;\n            margin-bottom: 10px;\n        }\n    }\n}\n\n@media only screen and (max-width: 1080px) {\n    .dob-container {\n        flex-wrap: wrap;\n        .dob-group {\n            width: 100%;\n        }\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
